import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';

interface CorporateFormSkeletonResources {
	onlineShop: string;
	tooltipOnlineShop: string;
	contacts: string;
	corporate: string;
	manager: string;
	tooltipManager: string;
}

interface CorporateFormSkeletonHelperOutput {
	resources: CorporateFormSkeletonResources;
}

export const useCorporateFormSkeletonHelper = (): CorporateFormSkeletonHelperOutput => {
	const t = useTranslation();

	const resources: CorporateFormSkeletonResources = {
		onlineShop: t('placeholders.formCorporateData.onlineShop'),
		tooltipOnlineShop: t('placeholders.formCorporateData.corporate.tooltipOnlineShop'),
		contacts: t('placeholders.formCorporateData.contacts'),
		corporate: t('general.input.corporate'),
		manager: t('placeholders.formCorporateData.contacts.manager'),
		tooltipManager: t('placeholders.formCorporateData.contacts.tooltipManager'),
	};

	return {
		resources,
	};
};
